import { render, staticRenderFns } from "./TableNormal.vue?vue&type=template&id=fbc27634&scoped=true"
import script from "./TableNormal.vue?vue&type=script&lang=js"
export * from "./TableNormal.vue?vue&type=script&lang=js"
import style0 from "./TableNormal.vue?vue&type=style&index=0&id=fbc27634&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc27634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc27634')) {
      api.createRecord('fbc27634', component.options)
    } else {
      api.reload('fbc27634', component.options)
    }
    module.hot.accept("./TableNormal.vue?vue&type=template&id=fbc27634&scoped=true", function () {
      api.rerender('fbc27634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/table/TableNormal.vue"
export default component.exports